import BaseAgencyScopeEntityDto from "@/models/Shared/BaseAgencyScopeEntityDto";
import LocationDto from "@/models/Locations/LocationDto";

export default class JourneyTemplateDto extends BaseAgencyScopeEntityDto {
    status = 0;
    locationId: string;
    location: LocationDto = new LocationDto();
    name = '';
    distanceOneWay = 0.0;
    travelTimeOneWay = 5;
}